import { render, staticRenderFns } from "./BulkActionDeleteIcon.vue?vue&type=template&id=2835a95a"
import script from "./BulkActionDeleteIcon.vue?vue&type=script&lang=js"
export * from "./BulkActionDeleteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports